import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { object, string } from "yup";
import TabPanelCmp from "../../components/tabPanel/tabPanelCmp";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import {
  AddRolePermissionsResponse,
  AddRoleRequest,
  GetPermissionsSearchResponse,
} from "../../models/role.model";
import {
  AddRolePermissions,
  DeleteRole,
  EditRole,
  GetPermissionsSearch,
  GetRolePermissions,
} from "../../services/role.service";
import PermissionRoleTabsTable from "./components/PermissionRoleTabsTable";
import TabsSkeleton from "./components/TabsSkeleton";

import AutocomplateCheckbox from "../../components/dropdown/AutocomplateCheckbox";
import UserRoleHeaderSkeleton from "./components/UserRoleHeaderSkeleton";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxWidth: "300px",
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const editReportValidationSchema = object().shape({
  title: string()
    .ensure()
    .required("لطفا نام فارسی را وارد نمایید")
    .max(150, "نام فارسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  name: string()
    .ensure()
    .required("لطفا نام انگلیسی را وارد نمایید")
    .max(150, "نام انگلیسی نباید بیش از ۱۵۰ کاراکتر باشد"),
});

const theme = createTheme({
  direction: "rtl",
});

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const RolePermissionTabs = () => {
  const [rolePermissons, setRolePermissions] = useState<
    AddRolePermissionsResponse[]
  >();
  const [openAddPermissionRoleModal, setOpenAddPermissionRoleModal] = useState(
    false
  );
  const [updateService, setUpdateService] = useState("");

  const [permissionSearch, setPermissionSearch] = useState<
    GetPermissionsSearchResponse[]
  >();
  const [permissionValue, setPermissionValue] = useState<any>();
  const [activeTab, setActiveTab] = useState<any>();
  const [valueUserRoles, setValueUserRoles] = useState<any[]>([]);
  const [openEditRoleModal, setOpenEditRoleModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  // const roles = useSelector((state: any) => state.roles);

  const { name: roleName, title: roleTitle } = JSON.parse(
    window.localStorage.getItem("RoleNameTitle")!
  );
  const initialValues: AddRoleRequest = {
    title: rolePermissons !== undefined ? roleTitle : "",
    name: rolePermissons !== undefined ? roleName : "",
  };

  const history = useHistory<{ roleId: number }>();
  const roleId =
    history?.location?.state?.roleId !== undefined
      ? history?.location?.state?.roleId
      : Number(window.localStorage.getItem("RoleId"));

  const { mutate: GetPermissionsSearchMutate } = useMutation(
    GetPermissionsSearch,
    {
      onSuccess: (data: GetPermissionsSearchResponse[]) => {
        if (data) {
          setPermissionSearch(data);
        }
      },
      onError: () => {},
    }
  );
  // const [name, setName] = useState("");
  // const name = roles?.roles.filter((role: any) => role.id === roleId);
  const { mutate: GetRolePermissionsMutate, isLoading } = useMutation(
    GetRolePermissions,
    {
      onSuccess: (data: AddRolePermissionsResponse[]) => {
        if (data) {
          setRolePermissions(data);
          // setName(data[0]?.roleTitle);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: AddRolePermissionsMutate } = useMutation(AddRolePermissions, {
    onSuccess: (data: AddRolePermissionsResponse[]) => {
      if (data) {
        GetRolePermissionsMutate({
          roleId: roleId,
        });
        GetPermissionsSearchMutate({
          roleId: roleId,
          isExclusivelyShowNonAssignedPermissions: true,
        });
        setOpenAddPermissionRoleModal(false);
        setValueUserRoles([]);
        setPermissionValue([]);
      }
    },
    onError: () => {},
  });
  const { mutate: EditRoleMutate } = useMutation(EditRole, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenEditRoleModal(false);

        // GetRolePermissionsMutate({
        //   roleId: roleId,
        // });
      }
    },
    onError: () => {},
  });
  const { mutate: DeleteRoleMutate } = useMutation(DeleteRole, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenDeleteModal(false);
        history.replace({
          pathname: "/RolePermissionList",
        });
      }
    },
    onError: () => {},
  });

  const apiData = rolePermissons?.filter(
    (item) => item.permissionType === "API"
  );
  const menuData = rolePermissons?.filter(
    (item) => item.permissionType === "Menu"
  );
  const reportData = rolePermissons?.filter(
    (item) => item.permissionType === "PBIReport"
  );

  const apiPermission = permissionSearch?.filter(
    (item) => item.permissionType === "API"
  );
  const menuPermission = permissionSearch?.filter(
    (item) => item.permissionType === "Menu"
  );
  const reportPermission = permissionSearch?.filter(
    (item) => item.permissionType === "PBIReport"
  );
  const unknownPermission = permissionSearch?.filter(
    (item) => item.permissionType === "Unknown"
  );

  useEffect(() => {
    GetRolePermissionsMutate({
      roleId: roleId,
    });
    GetPermissionsSearchMutate({
      roleId: roleId,
      isExclusivelyShowNonAssignedPermissions: true,
    });
  }, [updateService]);

  const handleSelectedDrop = (e: any, value: any) => {
    setPermissionValue(e);
    setValueUserRoles(value);
  };

  const handleAddPermission = () => {
    AddRolePermissionsMutate({
      roleId: roleId,
      permissionIds: permissionValue,
    });
  };

  const removeTag = (tagId: number) => {
    setValueUserRoles(valueUserRoles.filter((node) => node.id !== tagId));
  };

  const handleEditRole = (values: any) => {
    EditRoleMutate({
      id: roleId,
      title: values.title,
      name: values.name,
    });
    window.localStorage.setItem(
      "RoleNameTitle",
      JSON.stringify({ title: values.title, name: values.name })
    );
  };

  const handleDel = () => {
    DeleteRoleMutate({
      id: roleId,
    });
  };

  const tabs = [
    {
      id: 0,
      key: "Api",
      title: "وب سرویس",
      icon: (
        <img
          src="/images/api-icon.png"
          alt="api icon"
          style={{ marginBottom: "0" }}
        />
      ),
      child: !isLoading ? (
        <>
          <Typography
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            marginBottom={"15px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
            onClick={() => {
              setOpenAddPermissionRoleModal(true);
            }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            ثبت مجوز
          </Typography>
          <PermissionRoleTabsTable
            tableData={apiData!}
            setUpdate={setUpdateService}
            activeTab={activeTab}
          />
        </>
      ) : (
        <TabsSkeleton />
      ),
    },
    {
      id: 1,
      key: "menues",
      title: "منوها",
      icon: <MenuOutlinedIcon sx={{ marginBottom: "0 !important" }} />,
      child: (
        <>
          <Typography
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            marginBottom={"15px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
            onClick={() => {
              setOpenAddPermissionRoleModal(true);
            }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            افزودن منو
          </Typography>
          <PermissionRoleTabsTable
            tableData={menuData!}
            setUpdate={setUpdateService}
            activeTab={activeTab}
          />
        </>
      ),
    },
    {
      id: 2,
      key: "reports",
      title: "گزارشات",
      icon: <ListAltIcon sx={{ marginBottom: "0 !important" }} />,
      child: (
        <>
          <Typography
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            marginBottom={"15px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
            onClick={() => {
              setOpenAddPermissionRoleModal(true);
            }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            ثبت گزارش
          </Typography>
          <PermissionRoleTabsTable
            tableData={reportData!}
            setUpdate={setUpdateService}
            activeTab={activeTab}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Grid container>
        {!isLoading ? (
          <Grid
            item
            xs={12}
            sx={{
              background: "#F9FAFC",
              width: "100%",
              border: "1px solid #EDEFEF",
              borderRadius: "5px",
            }}
          >
            <Grid
              container
              padding={"1rem"}
              height={"100%"}
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"15px"}
            >
              <Grid item sx={{ display: "flex", alignItems: "center" }}>
                <ManageAccountsOutlinedIcon
                  sx={{
                    background: "#9AAFC4",
                    fontSize: "60px !important",
                    marginLeft: "10px",
                    aspectRatio: 1,
                    borderRadius: "50%",
                    padding: "5px",
                    color: "#F9FAFC",
                  }}
                />
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  <span style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                    {/* {name !== undefined && name[0]?.title} */}
                    {roleTitle}
                  </span>
                </Typography>
              </Grid>
              <Grid item>
                <Grid container>
                  <Grid item>
                    <Typography
                      sx={{ cursor: "pointer", color: "#1D4A87" }}
                      onClick={() => setOpenDeleteModal(true)}
                    >
                      <DeleteOutlineIcon sx={{ marginLeft: "5px" }} />
                      حذف نقش
                    </Typography>
                  </Grid>
                  <span
                    style={{
                      marginLeft: "2vh",
                      marginRight: "2vh",
                      background: "#CFD8DC",
                      height: "3vh",
                      width: "2px",
                    }}
                  ></span>
                  <Grid item>
                    <Typography
                      sx={{ cursor: "pointer", color: "#1D4A87" }}
                      onClick={() => setOpenEditRoleModal(true)}
                    >
                      <EditIcon sx={{ marginLeft: "5px" }} />
                      ویرایش نقش
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              background: "#F9FAFC",
              width: "100%",
              border: "1px solid #EDEFEF",
              borderRadius: "5px",
            }}
          >
            <UserRoleHeaderSkeleton />
          </Grid>
        )}
        <Grid item xs={12}>
          <span className="permissions-tabsPanel">
            <TabPanelCmp
              tab={tabs}
              colorTab={"#01af43"}
              setActiveTab={setActiveTab}
            />
          </span>
        </Grid>
        <div>
          <Modal
            open={openAddPermissionRoleModal}
            onClose={() => {
              setOpenAddPermissionRoleModal(false);
              setValueUserRoles([]);
              setPermissionValue(undefined);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={deactiveUserStyle}>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                marginY={"3rem"}
                fontSize={"14px"}
              >
                {activeTab === 2
                  ? "افزودن گزارش"
                  : activeTab === 1
                  ? "افزودن منو"
                  : "افزودن مجوز اختصاصی"}
              </Typography>
              <Grid container justifyContent={"center"} alignItems={"center"}>
                <Grid item marginBottom={"2rem"} width={"100%"}>
                  <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={theme}>
                      <div dir="rtl">
                        <AutocomplateCheckbox
                          name="permission"
                          id="permission"
                          value={permissionValue}
                          label={
                            activeTab === 2
                              ? "انتخاب گزارش*"
                              : activeTab === 1
                              ? "انتخاب منو*"
                              : "انتخاب مجوز*"
                          }
                          options={
                            activeTab === 2
                              ? reportPermission
                              : activeTab === 1
                              ? menuPermission
                              : apiPermission
                          }
                          onChange={handleSelectedDrop}
                          changeMultiSelect={handleSelectedDrop}
                          responseValue={valueUserRoles}
                        />
                      </div>
                    </ThemeProvider>
                  </CacheProvider>
                </Grid>
              </Grid>
              {valueUserRoles.length > 0 && (
                <Box
                  sx={{
                    borderTop: "1px solid #CCD1D6",
                    width: "100%",
                    marginBottom: "1rem",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#1D4A87",
                      marginTop: "10px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    {activeTab === 2
                      ? "گزارش های اضافه شده"
                      : activeTab === 1
                      ? "منوهای اضافه شده"
                      : "مجوزهای اضافه شده"}
                  </Typography>
                  <Grid
                    item
                    sx={{ display: "flex", gap: "7px", flexWrap: "wrap" }}
                  >
                    {valueUserRoles.map((node) => (
                      <Box
                        sx={{
                          background: "#EDEFEF",
                          padding: "3px 7px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderRadius: "5px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {node.title}
                        <Typography
                          sx={{ cursor: "pointer" }}
                          onClick={() => removeTag(node.id)}
                        >
                          <ClearIcon
                            sx={{ color: "#34495E", fontSize: "14px" }}
                          />
                        </Typography>
                      </Box>
                    ))}
                  </Grid>
                </Box>
              )}
              <Grid container justifyContent={"center"} gap={"1rem"}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    disabled={!permissionValue}
                    className={
                      !permissionValue
                        ? "btnForm disabledBtn"
                        : "btnForm SuccessDefault"
                    }
                    onClick={handleAddPermission}
                  >
                    ثبت
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1rem",
                      color: "#fff",
                      height: "40px",
                      background: "#607D8B",
                    }}
                    onClick={() => {
                      setOpenAddPermissionRoleModal(false);
                      setValueUserRoles([]);
                      setPermissionValue(undefined);
                    }}
                  >
                    بازگشت
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </div>

        {/* edit role modal */}
        <div>
          <Modal
            open={openEditRoleModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={deactiveUserStyle}>
              <Grid
                container
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"center"}
                gap={"1rem"}
              >
                <Typography
                  component={"p"}
                  display={"block"}
                  textAlign={"center"}
                  fontWeight={"bold"}
                  //   marginY={"3rem"}
                  fontSize={"14px"}
                  color={"#1D4A87"}
                >
                  ویرایش نقش سازمانی
                </Typography>
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleEditRole}
                  validateOnMount={true}
                  validationSchema={editReportValidationSchema}
                >
                  {({
                    handleSubmit,
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Grid
                        container
                        gap={"1rem"}
                        marginTop={"15px"}
                        maxWidth={"400px"}
                      >
                        <Grid item xs={12}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام فارسی"}
                            label={"نام فارسی"}
                            required={true}
                            name={"title"}
                            id={"title"}
                            value={values.title}
                            helperText={touched.title ? errors.title : ""}
                            error={touched.title && Boolean(errors.title)}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <MaterialTextFieldComponent
                            placeHolder={"نام انگلیسی"}
                            label={"نام انگلیسی"}
                            required={true}
                            name={"name"}
                            id={"name"}
                            value={values.name}
                            helperText={touched.name ? errors.name : ""}
                            error={touched.name && Boolean(errors.name)}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              if (
                                /^[آ-ی ء چ]+$/.test(e.key) &&
                                e.code !== "Space"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Grid
                            container
                            justifyContent={"center"}
                            alignItems={"center"}
                            gap={1}
                            marginBottom={"8px"}
                          >
                            <Grid item xs={5} width={"100%"}>
                              <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                sx={{ borderRadius: "5px !important" }}
                                disabled={
                                  values?.title === roleTitle &&
                                  values?.name === roleName
                                }
                                className={
                                  values?.title === roleTitle &&
                                  values?.name === roleName
                                    ? "btnForm disabledBtn"
                                    : "btnForm SuccessDefault"
                                }
                              >
                                ثبت
                              </Button>
                            </Grid>
                            <Grid item xs={5} width={"100%"}>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{
                                  fontSize: "1rem",
                                  color: "#fff",
                                  height: "40px",
                                  background: "#607D8B",
                                }}
                                sx={{ borderRadius: "5px !important" }}
                                onClick={() => setOpenEditRoleModal(false)}
                              >
                                انصراف
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
              </Grid>
            </Box>
          </Modal>
        </div>

        {/* delete role modal */}
        <div>
          <Modal
            open={openDeleteModal}
            onClose={() => setOpenDeleteModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={deactiveUserStyle}>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                marginBottom={"3rem"}
                fontSize={"14px"}
              >
                آیا از حذف نقش{" "}
                <span style={{ fontWeight: "bold", color: "#E6123D" }}>
                  "
                  {/* {rolePermissons !== undefined && rolePermissons[0]?.roleTitle} */}
                  {/* {name !== undefined && name[0]?.title}"
                   */}
                  {roleTitle}
                </span>{" "}
                اطمینان دارید؟
              </Typography>
              <Grid container justifyContent={"center"} gap={"1rem"}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  sx={{
                    backgroundColor: "#E6123D",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  padding={"0.5rem"}
                  maxWidth={"150px !important"}
                >
                  <Typography
                    textAlign={"center"}
                    color={"#FFF"}
                    fontWeight={"bold"}
                    // onClick={handleDel}
                    onClick={handleDel}
                  >
                    بله
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  sx={{
                    backgroundColor: "#607D8B",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  padding={"0.5rem"}
                  maxWidth={"150px !important"}
                >
                  <Typography
                    textAlign={"center"}
                    color={"#FFF"}
                    fontWeight={"bold"}
                    onClick={() => setOpenDeleteModal(false)}
                  >
                    خیر
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </div>
      </Grid>
    </>
  );
};

export default RolePermissionTabs;
